import { find } from 'lodash';
import { Maybe } from 'app/common/types';
import getServiceAssociatedWithNode from './getServiceAssociatedWithNode';
import { FlowNode } from '../flowState';
import { ServicesMap } from 'app/service/types';

const nodeAction = (node: Maybe<FlowNode>, services: ServicesMap) => {
  if (!node) return undefined;
  const _service = getServiceAssociatedWithNode(node, services) || {};
  return find(_service[node.type_of], { key: node.action });
};

export default nodeAction;
